/**
 * Share
 * A share plugin.
 * @version 3.0.0
 * @exports Share
 */
export default class Share {
	/**
	 * Constructor
	 * @public
	 */
	constructor() {
		/** Object placeholder that will contain page parameters used for sharing. */
		this.pageParams = {};

		/** Object containing urls for supported share services with placeholders for url (and optional title). */
		this.shareUrls = {
			facebook: 'https://www.facebook.com/sharer/sharer.php?u=[url]',
			twitter: 'https://twitter.com/home?status=[title]%20[url]',
			google: 'https://plus.google.com/share?url=[url]',
			linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=[url]',
			tumblr:
				'https://www.tumblr.com/widgets/share/tool?canonicalUrl=[url]&url=[url]&title=[title]',
			gmail:
				'https://mail.google.com/mail/u/0/?view=cm&fs=1&to&su=[title]&body=[url]&ui=2&tf=1',
			email: 'mailto:?subject=[title]&body=[url]',
		};

		this._getPageParams();
		this._initShareLinks();
	}

	/**
	 * Adds the correct sharing url for each share-link.
	 * @private
	 */
	_initShareLinks() {
		let links = document.querySelectorAll('[data-type="share"]');

		for (let i = 0; i < links.length; i++) {
			let link = links[i],
				shareService = link.getAttribute('data-share-service');

			if (shareService !== null) {
				if (shareService === 'print') {
					this._setupPrintLink(link);
				} else {
					link.setAttribute('href', this._getShareLink(shareService));
					if (shareService !== 'email') {
						link.setAttribute('target', '_blank');
					}
				}
			}
		}
	}

	/**
	 * Returns the url for a share-service.
	 * @param {String} service - The searvice name as a string.
	 * @private
	 */
	_getShareLink(service) {
		let shareUrl = '';

		if (this.shareUrls[service] !== undefined) {
			shareUrl = this.shareUrls[service].replace(
				/\[url\]/g,
				this.pageParams.url
			);
			shareUrl = shareUrl.replace(/\[title\]/g, this.pageParams.title);
		}

		return shareUrl;
	}

	/**
	 * Adds an onclick event to print current page.
	 * @param {Object} link - A link as a DOM node.
	 * @private
	 */
	_setupPrintLink(link) {
		link.addEventListener('click', event => {
			event.preventDefault();
			window.print();
		});
	}

	/**
	 * Collects the page parameters used when sharing.
	 * @private
	 */
	_getPageParams() {
		let metas = document.getElementsByTagName('meta');

		this.pageParams = {};

		for (let i = 0; i < metas.length; i++) {
			if (metas[i].getAttribute('property') === 'og:url') {
				this.pageParams.url = encodeURIComponent(
					metas[i].getAttribute('content')
				);
			}
			if (metas[i].getAttribute('property') === 'og:title') {
				this.pageParams.title = encodeURIComponent(
					metas[i].getAttribute('content')
				);
			}
		}

		if (this.pageParams.url === undefined) {
			this.pageParams.url = encodeURIComponent(window.location.href);
		}
		if (this.pageParams.title === undefined) {
			this.pageParams.title = encodeURIComponent(document.title);
		}
	}
}
